/* eslint-disable eqeqeq */
import { useContext, useEffect, useMemo, useState } from "react";
import KrFormContext, { KrFormContextLandslideType, LandslideDevelopment, LandslideMovementCause, NavHeadingsKROEnum } from "../../../../contexts/krFormContext";
import ButtonField from "../../../../components/buttonField/buttonField";
import { classNameBtn, iconPosition } from "../../../../components/shared/button/types/buttonProps";
import { styleFormField, styleFormFieldHalf, styleFormFieldOnFour, styleFormFieldOnSix, styleFormFieldOnThree, stylizationVerticalAlign } from "../../../../components/shared/stylization";
import { GenesisAndAgeTypes } from "../types/krFormView";
import { ButtonFieldProps } from "../../../../components/buttonField/types/buttonFieldProps";
import { ReactComponent as addCircleIcon } from '../../../../icons/add_circle.svg';
import { labelProps } from "../../../../components/shared/label/types/labelProps";
import RadioButtonField from "../../../../components/radioButtonField/radioButtonField";
import { RadioButtonFieldProps } from "../../../../components/radioButtonField/types/radioButtonFieldProps";
import Table from "../../../../components/shared/table/table";
import { TableProps } from "../../../../components/shared/table/types/tableProps";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { HeadersTable } from "../../../../helpers/featureTableConstruct";
import TableActions from "../../../../components/shared/table/tableActions/tableActions";
import ConfirmModal from "../../../../components/modalWindow/confirmModal";
import { Option, SelectInputProps } from "../../../../components/shared/selectInput/types/selectInputProps";
import { GetOptions, prepareDataSingleForSelect } from "../../../../helpers/prepareForSelect";
import SelectInput from "../../../../components/shared/selectInput/selectInput";
import { TextAreaFieldProps } from "../../../../components/textAreaField/types/textAreaFieldProps";
import TextAreaField from "../../../../components/textAreaField/textAreaField";
import { ReactComponent as eventIcon } from '../../../../icons/event.svg';
import Label from "../../../../components/shared/label/label";
import { AdditionalIcon } from "../../../../components/shared/additionalIcon/additionalIcon";
import { notifyError, notifyWarn } from "../../../../components/snackbar/snackbar";
import { FormSectionProps } from "./shared/types/formSectionProps";
import { createConfigValidation, validation } from "../../../../helpers/validation/validation";
import CollectiveLabelChip from "../../collectiveEditionView/components/collectiveLabelChip";
import CollectiveSelectField from "../../collectiveEditionView/collectiveField/collectiveSelectField";
import { genesisAndAgeTableList, tableRecord } from "../../../../helpers/form/genesisAndAgeHelper";
import { CollectivePreviewKey } from "../../../../helpers/collective/preview";
import { checkIfMarkedForCommentFilter, fireAddCommentBtnOnClickForRow, getFieldRef, getFieldRefForRow, getItemRef, getKRDictFieldNameForRow, renderSectionCommentBtn } from "../../../../helpers/form";
import { KROFieldDict } from "../../shared/commentsSidebar/fieldDict";
import { DateOptions, getAgeDict, getNumberOfDaysInMonth, getStartDevelopments, getYearOptions, MonthOptions } from "./genesisAndAgeUtils";

const GenesisAndAge = (props: FormSectionProps) => {
    const { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextLandslideType;
    const [activeBtn, setActiveBtn] = useState<GenesisAndAgeTypes | null>(null);
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [pointInTime, setPointInTime] = useState<number>(0);
    const [developmentRow, setDevelopmentRow] = useState<any>(null);
    const [radioButtonReload, setRadioButtonReload] = useState<any>(false);
    const [textareaReload, setTextareaReload] = useState<any>(false);
    const [textareaTimeReload, setTextareaTimeReload] = useState<any>(false);
    const [timeUnits, setTimeUnits] = useState<number | undefined>(undefined);
    const [tableError, setTableError] = useState<boolean>(false);
    const [tableErrorMsg, setTableErrorMsg] = useState<string>('');
    const [startDevelopments, setStartDevelopments] = useState<number[] | undefined>(getStartDevelopments(krForm?.developments));
    const [checkValidation, setCheckValidation] = useState<boolean>(false);
    const [visibilityRows, setVisibilityRows] = useState<string[]>([]);
    const [editRow, setEditRow] = useState<boolean>(false);
    const [daysOptionsReload, setDaysOptionsReload] = useState<boolean>(false);

    const [genesisAndAgeRecord, setGenesisAndAgeRecord] = useState<LandslideDevelopment>({});
    const [movementCauseRecord, setMovementCauseRecord] = useState<LandslideMovementCause[] | undefined>([]);
    const [focusTable, setFocusTable] = useState<boolean>(false);

    const refocus = () => {
        setFocusTable(true);
    }

    // Dicts
    const TimeTypeDict = useMemo(() => GetOptions("RODZAJ_OKRESU_CZASU_SID", krForm.dictionaries, true), [krForm.dictionaries]);
    const EventeTypeDict = useMemo(() => GetOptions("TYP_ZDARZENIA_SID", krForm.dictionaries), [krForm.dictionaries]);
    const MovementCauseDict = useMemo(() => GetOptions("PRZYCZYNA_RUCHU_SID", krForm.dictionaries, true), [krForm.dictionaries]);
    const PoraRokuDict = useMemo(() => GetOptions("PORA_ROKU_SID", krForm.dictionaries, true), [krForm.dictionaries]);

    const shortStratigraficDict = useMemo(() => {
        const StratigraficDict = GetOptions("STRATYGRAFIA_OD_SID", krForm.dictionaries);
        const visibleEpoch = ["czwartorzęd", "holocen", "plejstocen", "zlodowacenia północnopolskie"]
        return StratigraficDict?.filter(item => visibleEpoch.find(elem => elem === item.name));
    }, [krForm.dictionaries]);
    const ageDict = useMemo(getAgeDict, []);
    const yearOptions = useMemo(getYearOptions, []);
    const yearOptionsSliceCount = useMemo(() => {
        const minYear = 1970;
        var idx = yearOptions.findIndex(item => item.value === minYear.toString());
        return idx + 1;
    }, [yearOptions])

    const CreateDateOptions = (isFrom: boolean) => {
        var options: Option[] = [];
        var numberOfDays = getNumberOfDaysInMonth(isFrom ? genesisAndAgeRecord.datA_MIESIAC : genesisAndAgeRecord.datA_MIESIAC_DO, isFrom ? genesisAndAgeRecord.datA_ROK : genesisAndAgeRecord.datA_ROK_DO)
        for (var i = 1; i < numberOfDays + 1; i++) {
            options.push({ name: i.toString(), value: i.toString() });
        }
        return options;
    }

    // Validation
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            const currValidation = createConfigValidation("developments", false);
            const errorMsg = validation(currValidation, krForm.developments);
            if (errorMsg !== '') {
                setTableError(true);
                setTableErrorMsg(errorMsg);
            }
        }

        if (krForm.config?.check && !krForm.config.isValid) {
            var errorMsg = krForm.config?.ValidationError!["developments"]
            if (errorMsg && errorMsg !== '') {
                setTableError(true);
                setTableErrorMsg(errorMsg);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])

    const refreshValidation = (values: LandslideDevelopment[] | undefined) => {
        const currValidation = createConfigValidation("developments", false);
        const currValidationMsg = validation(currValidation, values);
        if (currValidationMsg) {
            setTableError(true);
            setTableErrorMsg(currValidationMsg);
        } else {
            setTableError(false);
            setTableErrorMsg('');
        }
    }

    // Buttons
    const getBtnProps = (actionType: GenesisAndAgeTypes, title: string, icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>,
        buttonSize?: classNameBtn, addDevelopment?: boolean): ButtonFieldProps => {
        let className = classNameBtn.Big + " body-txt-large";
        if (buttonSize) className = buttonSize;
        if (actionType === activeBtn && !addDevelopment) {
            className += " bigBtnActive";
        }
        return {
            BtnProps: {
                onClick: (e: any) => { addDevelopment ? addDevelop(e) : switchButton(actionType) },
                style: {
                    width: '100%',
                },
                className: className
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            additionalIcon: icon,
            iconPosition: iconPosition.Start,
            wrapperProps: {
                style: {
                    width: '49%',
                    paddingBottom: '10px'
                }
            }
        };
    }

    const switchButton = (actionType: GenesisAndAgeTypes) => {
        setActiveBtn(actionType);
        var Development = {
            tyP_ZDARZENIA_SID: actionType
        } as LandslideDevelopment;
        if (!editRow) {
            clearFields();
            setGenesisAndAgeRecord(Development);
        } else {
            setGenesisAndAgeRecord({ ...genesisAndAgeRecord, tyP_ZDARZENIA_SID: actionType });
        }
    }

    const clearFields = () => {
        setMovementCauseRecord([]);
        setTimeUnits(undefined);
        setPointInTime(0);
        setRadioButtonReload(!radioButtonReload);
        setCheckValidation(false);
    }

    const clearDateDetails = () => {
        setCheckValidation(false);
        setDaysOptionsReload(!daysOptionsReload);
        setGenesisAndAgeRecord({
            ...genesisAndAgeRecord,
            datA_ROK: undefined,
            datA_ROK_DO: undefined,
            datA_MIESIAC: undefined,
            datA_MIESIAC_DO: undefined,
            datA_DZIEN: undefined,
            datA_DZIEN_DO: undefined,
            porA_ROKU_SID: undefined,
            porA_ROKU_DO_SID: undefined,
            wiek: undefined,
            epoka: undefined
        })
    }

    // Radio buttons
    const getRadioBtnProps = (labelProps: labelProps, inputName: string, onClick: any, options: Option[], selectedValue: number | string | undefined, disabledValue?: any): RadioButtonFieldProps => {
        return {
            labelProps: labelProps,
            radioButtonProps: {
                inputName: inputName,
                onClick: onClick
            },
            style: {
                width: '100%',
                paddingBottom: '10px',
                textAlign: 'left',
                whiteSpace: 'pre-line'
            },
            Option: options,
            selectedValue: selectedValue,
            disabledValues: disabledValue,
            reload: radioButtonReload,
            configValidation: createConfigValidation("onlyRequired"),
            validationError: checkValidation
        }
    }

    const getLabelProps = (labelName: string) => {
        return {
            style: {
                paddingTop: '10px',
                marginBottom: '10px',
                display: "inline-block",
                width: '100%'
            },
            labelname: labelName
        }
    }

    const onClickDevelopmentRadioButton = (event: any, value: number) => {
        var Development = structuredClone(genesisAndAgeRecord);
        Development.pointInTime = value;
        if (value == 2) Development.przeD_PO_SID = 1;
        else if (value == 3) Development.przeD_PO_SID = 2;
        else Development.przeD_PO_SID = 3;

        if (value.toString() === '4') {
            if (Development) {
                Development.czY_ZAKRES_DAT = 1;
            }

        }
        else {
            if (Development) Development.czY_ZAKRES_DAT = 0;
        }
        if (value.toString() === '5') {
            Development.rodzaJ_OKRESU_CZASU_SID = undefined;
            Development.przeD_PO_SID = undefined;
        }
        setGenesisAndAgeRecord(Development);
        setPointInTime(value);
    }

    const onClickTimeUnitsRadioButton = (event: any, value: number) => {
        var Development = structuredClone(genesisAndAgeRecord);
        if (Development) {
            Development.rodzaJ_OKRESU_CZASU_SID = value;
            Development.osuwiskO_GID = krForm.landslideAttributes?.globalid;
        }
        setGenesisAndAgeRecord(Development);
        setTimeUnits(value);
    }

    // Date selects
    const getSelectInputProps = (placeholder: string, style: any, options: Option[] | undefined, selectedOptions: Option[] | undefined, onChange: any, optionsSliceCount?: number): SelectInputProps => {
        return {
            placeHolder: placeholder,
            style: style,
            hasInputTags: true,
            options: options,
            onlySingleTag: true,
            optionsSliceCount: optionsSliceCount,
            selectedOptions: selectedOptions,
            onChange: onChange,
            configValidation: createConfigValidation("onlyRequired"),
            validationError: checkValidation
        }
    }

    const YearOnChange = (opt: Option[]) => {
        var Development = { ...genesisAndAgeRecord };
        if (Development) {
            Development.datA_ROK = opt.length > 0 ? opt[0].value as number : undefined;
            Development.osuwiskO_GID = krForm.landslideAttributes?.globalid;
        }
        setGenesisAndAgeRecord(Development);
        setDaysOptionsReload(!daysOptionsReload);
    }

    const YearAfterOnChange = (opt: Option[]) => {
        var Development = { ...genesisAndAgeRecord };
        if (Development) {
            Development.datA_ROK_DO = opt.length > 0 ? opt[0].value as number : undefined;
            Development.osuwiskO_GID = krForm.landslideAttributes?.globalid;
        }
        setGenesisAndAgeRecord(Development);
        setDaysOptionsReload(!daysOptionsReload);
    }

    const MonthOnChange = (opt: Option[]) => {
        var Development = { ...genesisAndAgeRecord };
        if (Development) {
            Development.datA_MIESIAC = opt.length > 0 ? opt[0].value as number : undefined;
            Development.osuwiskO_GID = krForm.landslideAttributes?.globalid;
        }
        setGenesisAndAgeRecord(Development);
        setDaysOptionsReload(!daysOptionsReload);
    }

    const MonthAfterOnChange = (opt: Option[]) => {
        var Development = { ...genesisAndAgeRecord };
        if (Development) {
            Development.datA_MIESIAC_DO = opt.length > 0 ? opt[0].value as number : undefined;
            Development.osuwiskO_GID = krForm.landslideAttributes?.globalid;
        }
        setGenesisAndAgeRecord(Development);
        setDaysOptionsReload(!daysOptionsReload);
    }

    const DayOnChange = (opt: Option[]) => {
        var Development = { ...genesisAndAgeRecord };
        if (Development) {
            Development.datA_DZIEN = opt.length > 0 ? opt[0].value as number : undefined;
            Development.osuwiskO_GID = krForm.landslideAttributes?.globalid;
        }
        setGenesisAndAgeRecord(Development);
    }

    const DayAfterOnChange = (opt: Option[]) => {
        var Development = { ...genesisAndAgeRecord };
        if (Development) {
            Development.datA_DZIEN_DO = opt.length > 0 ? opt[0].value as number : undefined;
            Development.osuwiskO_GID = krForm.landslideAttributes?.globalid;
        }
        setGenesisAndAgeRecord(Development);
    }

    const PoraRokuOnChange = (opt: Option[]) => {
        var Development = { ...genesisAndAgeRecord };
        if (Development) {
            Development.porA_ROKU_SID = opt.length > 0 ? opt[0].value as number : undefined;
            Development.osuwiskO_GID = krForm.landslideAttributes?.globalid;
        }
        setGenesisAndAgeRecord(Development);
    }

    const PoraRokuAfterOnChange = (opt: Option[]) => {
        var Development = { ...genesisAndAgeRecord };
        if (Development) {
            Development.porA_ROKU_DO_SID = opt.length > 0 ? opt[0].value as number : undefined;
            Development.osuwiskO_GID = krForm.landslideAttributes?.globalid;
        }
        setGenesisAndAgeRecord(Development);
    }

    const AgeOnChange = (opt: Option[]) => {
        var Development = { ...genesisAndAgeRecord };
        if (Development) {
            Development.wiek = opt.length > 0 ? opt[0].name as string : undefined;
            Development.osuwiskO_GID = krForm.landslideAttributes?.globalid;
        }
        setGenesisAndAgeRecord(Development);
    }

    const EpocaOnChange = (opt: Option[]) => {
        var Development = { ...genesisAndAgeRecord };
        if (Development) {
            Development.epoka = opt.length > 0 ? opt[0].name as string : undefined;
            Development.osuwiskO_GID = krForm.landslideAttributes?.globalid;
        }
        setGenesisAndAgeRecord(Development);
    }

    // Description text area
    var textAreaTimeProps: TextAreaFieldProps = {
        labelName: 'Czas uwagi',
        textAreaPlaceholder: 'Dodaj opis',
        textareaSharedProps: {
            className: 'body-txt-large',
            style: {
                width: '100%',
                minHeight: '85px'
            }
        },
        configValidation: pointInTime == 5 ? createConfigValidation("onlyRequired") : undefined,
        validationError: pointInTime == 5 ? checkValidation : undefined,
        disabled: false,
        pristine: true,
        setValue: (value: any) => {
            var Development = { ...genesisAndAgeRecord };
            if (Development) {
                Development.datA_UWAGI = value;
                Development.osuwiskO_GID = krForm.landslideAttributes?.globalid;
                setGenesisAndAgeRecord(Development);
                setTextareaTimeReload(!textareaTimeReload);
            }
        },
        dynamicResize: true,
        value: genesisAndAgeRecord.datA_UWAGI,
        reload: textareaTimeReload
    }

    // Description text area
    var textAreaDevelopmentProps: TextAreaFieldProps = {
        labelName: 'Opis uwagi',
        textAreaPlaceholder: 'Dodaj opis',
        textareaSharedProps: {
            className: 'body-txt-large',
            style: {
                width: '100%',
                minHeight: '85px'
            }
        },
        configValidation: undefined,
        validationError: undefined,
        disabled: false,
        pristine: true,
        setValue: (value: any) => {
            var Development = { ...genesisAndAgeRecord };
            if (Development) {
                Development.genezA_OPIS = value;
                Development.osuwiskO_GID = krForm.landslideAttributes?.globalid;
                setGenesisAndAgeRecord(Development);
                setTextareaReload(!textareaReload);
            }
        },
        dynamicResize: true,
        value: genesisAndAgeRecord.genezA_OPIS,
        reload: textareaReload
    }

    // Movement cause select
    const handleMovementCauseOnChange = (opt: Option[] | undefined) => {
        if (opt) {
            const causes = opt.map(op => {
                const existing = movementCauseRecord?.find(item => item.przyczynA_RUCHU_SID === op.value);
                if (existing) {
                    return {
                        ...existing,
                        przyczynA_RUCHU_SID: op.value
                    } as LandslideMovementCause
                } else {
                    return {
                        przyczynA_RUCHU_SID: op.value
                    } as LandslideMovementCause
                }
            })
            setMovementCauseRecord(causes);
        } else {
            setMovementCauseRecord([]);
        }
    }

    const selectedMovementCause = useMemo(() => {
        var options: Option[] | undefined = [];
        if (movementCauseRecord) {
            options = MovementCauseDict?.filter(item => movementCauseRecord.some(elem => elem.przyczynA_RUCHU_SID === item.value));
        }
        return options ? options : [];
    }, [MovementCauseDict, movementCauseRecord])

    // Add event record
    const addDevelop = (e: any) => {
        if (CheckValidation() && CheckDateRangeValidation()) {
            const oldDevelopments = krForm?.developments ? krForm?.developments : [];
            let newDevelopments: LandslideDevelopment[] = [];
            let oldMovementCause = krForm.movementCause ? krForm.movementCause : [];
            if (movementCauseRecord) {
                const newObject = { ...genesisAndAgeRecord };
                if (!editRow) newObject.kolejnosc = oldDevelopments.length;
                const isNextPowstanie = oldDevelopments.find((development) => {
                    return (development.tyP_ZDARZENIA_SID === newObject.tyP_ZDARZENIA_SID && newObject.tyP_ZDARZENIA_SID === 1) &&
                        (development.globalid ? development.globalid !== newObject.globalid : development.localUUID !== newObject.localUUID);
                })
                if (isNextPowstanie) {
                    notifyWarn({ message: "Powstanie już istnieje w tabeli, nie można dodać rekordu." });
                } else {
                    if (editRow) {
                        newDevelopments = oldDevelopments.map(item => (item.globalid ? item.globalid !== newObject.globalid : item.localUUID !== newObject.localUUID) ? { ...item } : newObject);
                    } else {
                        newObject.localUUID = crypto.randomUUID();
                        newDevelopments = oldDevelopments.filter(item => item.globalid ? item.globalid !== newObject.globalid : item.localUUID !== newObject.localUUID);
                        newDevelopments.push(newObject);
                    }
                    const newMovementCause = oldMovementCause.filter(item => {
                        if (newObject.globalid) {
                            return item.osuwiskO_ROZWOJ_GID !== newObject.globalid;
                        }
                        return item.devId !== newObject.localUUID;
                    });

                    for (var j = 0; j < movementCauseRecord.length; j++) {
                        const newRecord = {
                            ...movementCauseRecord[j],
                            idx: newObject.kolejnosc,
                            osuwiskO_ROZWOJ_GID: newObject.globalid ? newObject.globalid : undefined,
                            devId: newObject.globalid ? newObject.globalid : newObject.localUUID
                        };
                        newMovementCause.push(newRecord);
                    }

                    const form = { ...krForm, developments: newDevelopments, movementCause: newMovementCause };
                    refreshValidation(form.developments);
                    setkrForm(form);
                    clearDateDetails();
                    if (editRow) handleCloseClick();
                }
                setStartDevelopments(getStartDevelopments(newDevelopments));
            }
        }
    }

    const CheckDateRangeValidation = () => {
        var check = true;

        if (genesisAndAgeRecord.czY_ZAKRES_DAT === 1) {
            const rodzajCzasu = genesisAndAgeRecord.rodzaJ_OKRESU_CZASU_SID as number;
            const yearFrom = Number(genesisAndAgeRecord.datA_ROK);
            const yearTo = Number(genesisAndAgeRecord.datA_ROK_DO);

            if ([1, 2, 3, 4].includes(rodzajCzasu) && (yearFrom > yearTo)) check = false;
            if (check && [1, 2].includes(rodzajCzasu) &&
                (Number(genesisAndAgeRecord.datA_MIESIAC) > Number(genesisAndAgeRecord.datA_MIESIAC_DO)) &&
                (yearFrom === yearTo)) check = false;
            if (check && rodzajCzasu == 1 &&
                (Number(genesisAndAgeRecord.datA_DZIEN) > Number(genesisAndAgeRecord.datA_DZIEN_DO)) &&
                (Number(genesisAndAgeRecord.datA_MIESIAC) === Number(genesisAndAgeRecord.datA_MIESIAC_DO)) &&
                (yearFrom === yearTo)) check = false;
            if (check && rodzajCzasu == 4 &&
                (checkSeasonsOrder(genesisAndAgeRecord.porA_ROKU_SID!) > checkSeasonsOrder(genesisAndAgeRecord.porA_ROKU_DO_SID!)) &&
                (yearFrom === yearTo)) check = false;
        }

        if (!check) notifyError({ message: "'Data do' nie może być wcześniejsza niż 'Data od'" });
        return check;
    }

    const checkSeasonsOrder = (dictId: number) => {
        var order = ["wiosna", "lato", "jesień", "zima"];
        var rec = PoraRokuDict?.find(item => item.value === dictId);
        return order.findIndex(item => item === rec?.name);
    }

    const CheckValidation = () => {
        setCheckValidation(true);

        if (movementCauseRecord === undefined || movementCauseRecord.length === 0) return false;

        // If uncertain point in time
        if (pointInTime == 5) {
            if (genesisAndAgeRecord.datA_UWAGI === undefined || genesisAndAgeRecord.datA_UWAGI === null) return false;
        }
        // If not uncertain point in time
        else {
            if (genesisAndAgeRecord.rodzaJ_OKRESU_CZASU_SID === undefined || genesisAndAgeRecord.rodzaJ_OKRESU_CZASU_SID === null) return false;
            if ((genesisAndAgeRecord.datA_ROK === undefined || genesisAndAgeRecord.datA_ROK === null) && [1, 2, 3, 4].includes(genesisAndAgeRecord.rodzaJ_OKRESU_CZASU_SID)) return false;
            if ((genesisAndAgeRecord.datA_MIESIAC === undefined || genesisAndAgeRecord.datA_MIESIAC === null) && [1, 2].includes(genesisAndAgeRecord.rodzaJ_OKRESU_CZASU_SID)) return false;
            if ((genesisAndAgeRecord.datA_DZIEN === undefined || genesisAndAgeRecord.datA_DZIEN === null) && genesisAndAgeRecord.rodzaJ_OKRESU_CZASU_SID === 1) return false;
            if ((genesisAndAgeRecord.porA_ROKU_SID === undefined || genesisAndAgeRecord.porA_ROKU_SID === null) && genesisAndAgeRecord.rodzaJ_OKRESU_CZASU_SID === 4) return false;
        }

        // If time range
        if (pointInTime == 4) {
            if ((genesisAndAgeRecord.datA_ROK_DO === undefined || genesisAndAgeRecord.datA_ROK_DO === null) && [1, 2, 3, 4].includes(genesisAndAgeRecord.rodzaJ_OKRESU_CZASU_SID!)) return false;
            if ((genesisAndAgeRecord.datA_MIESIAC_DO === undefined || genesisAndAgeRecord.datA_MIESIAC_DO === null) && [1, 2].includes(genesisAndAgeRecord.rodzaJ_OKRESU_CZASU_SID!)) return false;
            if ((genesisAndAgeRecord.datA_DZIEN_DO === undefined || genesisAndAgeRecord.datA_DZIEN_DO === null) && genesisAndAgeRecord.rodzaJ_OKRESU_CZASU_SID === 1) return false;
            if ((genesisAndAgeRecord.porA_ROKU_DO_SID === undefined || genesisAndAgeRecord.porA_ROKU_DO_SID === null) && genesisAndAgeRecord.rodzaJ_OKRESU_CZASU_SID === 4) return false;
        }
        else {
            if ((genesisAndAgeRecord.wiek === undefined || genesisAndAgeRecord.wiek === null) && genesisAndAgeRecord.rodzaJ_OKRESU_CZASU_SID === 5) return false;
            if ((genesisAndAgeRecord.epoka === undefined || genesisAndAgeRecord.epoka === null) && genesisAndAgeRecord.rodzaJ_OKRESU_CZASU_SID === 6) return false;
        }

        return true;
    }

    // Event table
    const handleDeleteClick = (row: any) => {
        setDevelopmentRow(row);
        setConfirmation(true);
        handleCloseClick();
    }

    const deleteDevelopment = (row: any) => {
        if (krForm !== null && krForm.developments) {
            const newDevelopments = krForm.developments.filter((item: LandslideDevelopment) => {
                return row.id ? row.id !== item.globalid : row.localUUID !== item.localUUID
            }).map((item, idex) => {
                return { ...item, kolejnosc: idex }
            });
            const modifiedCauses: LandslideMovementCause[] = [];
            for (var i = 0; i < newDevelopments.length; i++) {
                const d = newDevelopments[i];
                if (krForm?.movementCause) {
                    for (var c = 0; c < krForm.movementCause.length; c++) {
                        const cause = krForm.movementCause[c];
                        if (d.globalid ? cause.osuwiskO_ROZWOJ_GID === d.globalid : cause.devId === d.localUUID) {
                            modifiedCauses.push({ ...cause, idx: d.kolejnosc })
                        }
                    }
                }
            }

            const form = { ...krForm, developments: newDevelopments, movementCause: modifiedCauses };
            refreshValidation(form.developments);
            setkrForm(form);
            setStartDevelopments(getStartDevelopments(newDevelopments));
        }
    }

    const draggableRows = props.editMode;

    const cellAction = (properties: CellContext<any, unknown>) => {
        return (<TableActions
            row={properties.row}
            objectType={"rasters"}
            deleteClickHandler={handleDeleteClick}
            editClickHandler={handleEditClick}
            closeClickHandler={handleCloseClick}
            visibilityRows={visibilityRows}
            fieldName={properties.row.original.id ? "id" : "localUUID"}
            draggableStyle={draggableRows}
            addCommentBtnVisible={!props.editMode}
            addCommentBtnClickHandler={handleAddCommentClick}
            addCommentBtnRef={getAddCommentBtnRef}
            checkIfMarkedForCommentFilter={checkIfRowMarkedForCommentFilter}
        />)
    }

    const checkIfRowMarkedForCommentFilter = (row: any) => {
        if (props.markedFieldForCommentFiltering) {
            return checkIfMarkedForCommentFilter(KROFieldDict.wiekGen_zdarzenie, row.id, props.markedFieldForCommentFiltering)
        }
    }

    const handleEditClick = (row: any) => {
        if (visibilityRows.length === 0) {
            setVisibilityRows([...visibilityRows, row.id ? row.id : row.localUUID]);
            setEditRow(true);
            var editedRow = structuredClone(krForm.developments?.find(item => row.id ? row.id === item.globalid : row.localUUID === item.localUUID));
            if (editedRow) {
                if (editedRow.tyP_ZDARZENIA_SID) setActiveBtn(editedRow.tyP_ZDARZENIA_SID);
                if (editedRow.pointInTime) setPointInTime(editedRow.pointInTime)
                else {
                    var time = getPointInTime(editedRow);
                    editedRow.pointInTime = time;
                    setPointInTime(time);
                }
                setTimeUnits(editedRow.rodzaJ_OKRESU_CZASU_SID);
                setGenesisAndAgeRecord(editedRow);

                if (krForm?.movementCause) {
                    const causes = krForm.movementCause.filter(mov => editedRow?.globalid ? mov.osuwiskO_ROZWOJ_GID === editedRow.globalid : mov.devId === editedRow?.localUUID);
                    setMovementCauseRecord(structuredClone(causes));
                } else {
                    setMovementCauseRecord([]);
                }
            }
        }
    }

    const getPointInTime = (rec: LandslideDevelopment) => {
        var pointInTime = 0;

        if (rec.przeD_PO_SID === 1) pointInTime = 2;
        else if (rec.przeD_PO_SID === 2) pointInTime = 3;
        else if (rec.czY_ZAKRES_DAT === 1) pointInTime = 4;
        else if (hasPointInTime(rec)) pointInTime = 1;
        else pointInTime = 5

        return pointInTime
    }

    const hasPointInTime = (rec: LandslideDevelopment) => {
        return (rec.datA_DZIEN || rec.datA_MIESIAC || rec.datA_ROK || rec.porA_ROKU_SID || rec.wiek || rec.epoka)
    }

    const handleCloseClick = () => {
        setVisibilityRows([]);
        setEditRow(false);
        setActiveBtn(null)
    }

    const handleAddCommentClick = (row: any) => {
        fireAddCommentBtnOnClickForRow(KROFieldDict.wiekGen_zdarzenie, row.id,
            "Wiersz sekcji: Wiek i geneza osuwiska",
            props.setNewCommentFieldDetails!);
    }

    const getAddCommentBtnRef = (node: any, row: any) => {
        getFieldRefForRow(node, KROFieldDict.wiekGen_zdarzenie, row.id, props.getMapForComment!);
    }

    let headers = {
        zdarzenie: "Zdarzenie",
        czas: "Czas",
        czasUwagi: "Czas uwagi",
        uwagi: "Opis uwagi",
        przyczyny: "Przyczyny"
    };

    const createTableList = () => {
        return genesisAndAgeTableList(krForm, MovementCauseDict, EventeTypeDict, PoraRokuDict);
    }

    const handleReorderRows = (tableRecs: tableRecord[]) => {
        var causeList = krForm?.movementCause ? structuredClone(krForm?.movementCause) : [];
        var developmentsCopy = structuredClone(krForm.developments);
        for (var i = 0; i < tableRecs.length; i++) {
            const rec = tableRecs[i];
            const itemObject = developmentsCopy?.find(item => item.globalid ? item.globalid === rec.id : item.localUUID === rec.localUUID);
            if (itemObject) {
                itemObject.kolejnosc = i;
                for (var c = 0; c < causeList.length; c++) {
                    const cause = causeList[c];
                    if (itemObject?.globalid ? cause.osuwiskO_ROZWOJ_GID === rec.id : cause.devId === rec.localUUID) {
                        cause.idx = i;
                    }
                }
            }
        }
        const newForm = { ...krForm, developments: developmentsCopy, movementCause: causeList };
        setkrForm(newForm);
    }

    var tableProps: TableProps = {
        columnAliases: headers,
        columnHelper: createColumnHelper<HeadersTable>(),
        columnNames: Object.keys(headers),
        cellActions: cellAction,
        data: krForm.developments ? createTableList() : [],
        loading: false,
        className: "table",
        draggableRows: draggableRows,
        tableError: props.collectiveEdition ? undefined : tableError,
        tableErrorMsg: props.collectiveEdition ? undefined : tableErrorMsg,
        handleReorderRows: handleReorderRows,
        setCommentsFilter: (row: any) => { if (props.setCommentsFilter) props.setCommentsFilter(getKRDictFieldNameForRow(KROFieldDict.wiekGen_zdarzenie, row.id)); },
        checkIfMarkedForCommentFilter: (row: any) => { checkIfRowMarkedForCommentFilter(row) },
        narrowTableForCommentBtns: !props.editMode,
        refocus: focusTable,
        setRefocusTable: setFocusTable
    }

    const confirm = () => {
        setConfirmation(false);
        deleteDevelopment(developmentRow);
    }

    const cancel = () => {
        setConfirmation(false);
    }

    const getQuestion = () => {
        return `Czy na pewno chcesz usunąć zdarzenie?`;
    }

    // Render
    const createStyleForm = () => {
        if (timeUnits == 1) return styleFormFieldOnSix;
        if (timeUnits == 2) return styleFormFieldOnFour;
        if (timeUnits == 3) return styleFormFieldHalf;
    }

    const SubElementsCreation = () => {
        if (pointInTime == 4 && (timeUnits == 5 || timeUnits == 6)) {
            setTimeUnits(undefined);
            setGenesisAndAgeRecord({ ...genesisAndAgeRecord, rodzaJ_OKRESU_CZASU_SID: undefined });
        }

        if (activeBtn === GenesisAndAgeTypes.Creation) {
            return (
                <>
                    <RadioButtonField {...getRadioBtnProps(
                        getLabelProps("Wybierz"),
                        "developmentRadio",
                        onClickDevelopmentRadioButton,
                        DateOptions,
                        (pointInTime as any).toString()
                    )} />
                </>
            )
        }
        if (activeBtn === GenesisAndAgeTypes.Development) {
            return (
                <>
                    <RadioButtonField {...getRadioBtnProps(
                        getLabelProps("Wybierz"),
                        "developmentRadio",
                        onClickDevelopmentRadioButton,
                        DateOptions,
                        (pointInTime as any).toString()
                    )} />
                </>
            )
        }
        return;
    }

    const getSelectedDay = (value: string | undefined, isFrom: boolean) => {
        var selected = prepareDataSingleForSelect(CreateDateOptions(isFrom), [value]);
        if (selected.length === 0 && value !== undefined) {
            isFrom ? DayOnChange([]) : DayAfterOnChange([]);
        }
        return selected
    }

    const renderTime = () => {
        return <>{activeBtn != null ? SubElementsCreation() : null}
            {

                (activeBtn != null && pointInTime != 0) ? <>
                    {pointInTime != 5 ? <>
                        <RadioButtonField {...getRadioBtnProps(
                            getLabelProps("Jednostki czasu"),
                            "timeTypeRadio",
                            onClickTimeUnitsRadioButton,
                            TimeTypeDict ? TimeTypeDict : [],
                            timeUnits,
                            pointInTime == 4 ? [5, 6] : undefined
                        )} />
                        {
                            // eslint-disable-next-line eqeqeq

                            // If point in time, before or after
                            (pointInTime == 1 || pointInTime == 2 || pointInTime == 3) ?
                                <>
                                    {/* Season */}
                                    {timeUnits == 4 ? <>
                                        <div style={{ alignItems: 'middle', display: 'flex', width: '100%' }}>{AdditionalIcon(eventIcon, undefined, undefined, true)}<Label labelname="Pora roku" style={{ textAlign: 'left' }} /></div>
                                        <SelectInput {...getSelectInputProps(
                                            "Pora roku",
                                            styleFormFieldOnThree,
                                            PoraRokuDict,
                                            prepareDataSingleForSelect(PoraRokuDict, [genesisAndAgeRecord.porA_ROKU_SID]),
                                            PoraRokuOnChange
                                        )} />
                                    </> : null}

                                    {/* Date: year, month or day */}
                                    {(timeUnits == 1 || timeUnits == 2 || timeUnits == 3) ? <div style={{ alignItems: 'middle', display: 'flex', width: '100%' }}>
                                        {AdditionalIcon(eventIcon, undefined, undefined, true)}<Label labelname="Data" style={{ textAlign: 'left' }} /></div> : null}

                                    {timeUnits == 1 || timeUnits == 2 || timeUnits == 3 || timeUnits == 4 ?
                                        <SelectInput {...getSelectInputProps(
                                            "Rok",
                                            styleFormFieldOnThree,
                                            yearOptions,
                                            prepareDataSingleForSelect(yearOptions, [genesisAndAgeRecord.datA_ROK?.toString()]),
                                            YearOnChange,
                                            yearOptionsSliceCount
                                        )} /> : null}
                                    {timeUnits == 1 || timeUnits == 2 ?
                                        <SelectInput {...getSelectInputProps(
                                            "Miesiąc",
                                            styleFormFieldOnThree,
                                            MonthOptions,
                                            prepareDataSingleForSelect(MonthOptions, [genesisAndAgeRecord.datA_MIESIAC?.toString()]),
                                            MonthOnChange
                                        )} /> : null}
                                    {timeUnits == 1 ?
                                        <SelectInput {...getSelectInputProps(
                                            "Dzień",
                                            styleFormFieldOnThree,
                                            CreateDateOptions(true),
                                            getSelectedDay(genesisAndAgeRecord.datA_DZIEN?.toString(), true),
                                            DayOnChange,
                                        )} reload={daysOptionsReload} /> : null}

                                    {/* Century */}
                                    {timeUnits == 5 ? <>
                                        <div style={{ alignItems: 'middle', display: 'flex', width: '49%' }}>{AdditionalIcon(eventIcon, undefined, undefined, true)}<Label labelname="Wiek" style={{ textAlign: 'left' }} /></div>
                                        <SelectInput {...getSelectInputProps(
                                            "Wiek",
                                            styleFormField,
                                            ageDict,
                                            prepareDataSingleForSelect(ageDict, [genesisAndAgeRecord.wiek]),
                                            AgeOnChange
                                        )} />
                                    </> : null}

                                    {/* Epoch */}
                                    {timeUnits == 6 ? <>
                                        <div style={{ alignItems: 'middle', display: 'flex', width: '49%' }}>{AdditionalIcon(eventIcon, undefined, undefined, true)}<Label labelname="Epoka" style={{ textAlign: 'left' }} /></div>
                                        <SelectInput {...getSelectInputProps(
                                            "Epoka",
                                            styleFormField,
                                            shortStratigraficDict,
                                            prepareDataSingleForSelect(shortStratigraficDict, [genesisAndAgeRecord.epoka]),
                                            EpocaOnChange
                                        )} />
                                    </> : null}

                                </> : null
                        }

                        {/* If range of time */}
                        {pointInTime == 4 ?
                            <>
                                {timeUnits == 1 || timeUnits == 2 || timeUnits == 3 ? <>
                                    <div style={{ alignItems: 'middle', display: 'flex', width: '49%' }}>{AdditionalIcon(eventIcon, undefined, undefined, true)}<Label labelname="Data od" style={{ textAlign: 'left' }} /></div>
                                    <div style={{ alignItems: 'middle', display: 'flex', width: '49%' }}>{AdditionalIcon(eventIcon, undefined, undefined, true)}<Label labelname="Data do" style={{ textAlign: 'left' }} /></div></> :
                                    null}

                                {/* Start date: year, month or day */}
                                {timeUnits == 1 || timeUnits == 2 || timeUnits == 3 ?
                                    <SelectInput {...getSelectInputProps(
                                        "Rok",
                                        createStyleForm(),
                                        yearOptions,
                                        prepareDataSingleForSelect(yearOptions, [genesisAndAgeRecord.datA_ROK?.toString()]),
                                        YearOnChange,
                                        yearOptionsSliceCount
                                    )} /> : null}
                                {timeUnits == 1 || timeUnits == 2 ?
                                    <SelectInput {...getSelectInputProps(
                                        "Miesiąc",
                                        createStyleForm(),
                                        MonthOptions,
                                        prepareDataSingleForSelect(MonthOptions, [genesisAndAgeRecord.datA_MIESIAC?.toString()]),
                                        MonthOnChange
                                    )} /> : null}
                                {timeUnits == 1 ?
                                    <SelectInput {...getSelectInputProps(
                                        "Dzień",
                                        createStyleForm(),
                                        CreateDateOptions(true),
                                        getSelectedDay(genesisAndAgeRecord.datA_DZIEN?.toString(), true),
                                        DayOnChange
                                    )} reload={daysOptionsReload} /> : null}

                                {/* End date: year, month or day */}
                                {timeUnits == 1 || timeUnits == 2 || timeUnits == 3 ?
                                    <SelectInput {...getSelectInputProps(
                                        "Rok",
                                        createStyleForm(),
                                        yearOptions,
                                        prepareDataSingleForSelect(yearOptions, [genesisAndAgeRecord.datA_ROK_DO?.toString()]),
                                        YearAfterOnChange,
                                        yearOptionsSliceCount
                                    )} /> : null}
                                {timeUnits == 1 || timeUnits == 2 ?
                                    <SelectInput {...getSelectInputProps(
                                        "Miesiąc",
                                        createStyleForm(),
                                        MonthOptions,
                                        prepareDataSingleForSelect(MonthOptions, [genesisAndAgeRecord.datA_MIESIAC_DO?.toString()]),
                                        MonthAfterOnChange
                                    )} /> : null}
                                {timeUnits == 1 ?
                                    <SelectInput {...getSelectInputProps(
                                        "Dzień",
                                        styleFormFieldOnSix,
                                        CreateDateOptions(false),
                                        getSelectedDay(genesisAndAgeRecord.datA_DZIEN_DO?.toString(), false),
                                        DayAfterOnChange
                                    )} reload={daysOptionsReload} /> : null}

                                {/* Season */}
                                {timeUnits == 4 ? <>
                                    <div style={{ alignItems: 'middle', display: 'flex', width: '49%' }}>{AdditionalIcon(eventIcon, undefined, undefined, true)}<Label labelname="Pora roku od" style={{ textAlign: 'left' }} /></div>
                                    <div style={{ alignItems: 'middle', display: 'flex', width: '49%' }}>{AdditionalIcon(eventIcon, undefined, undefined, true)}<Label labelname="Pora roku do" style={{ textAlign: 'left' }} /></div>

                                    <SelectInput {...getSelectInputProps(
                                        "Pora roku",
                                        styleFormFieldOnFour,
                                        PoraRokuDict,
                                        prepareDataSingleForSelect(PoraRokuDict, [genesisAndAgeRecord.porA_ROKU_SID]),
                                        PoraRokuOnChange
                                    )} />
                                    <SelectInput {...getSelectInputProps(
                                        "Rok",
                                        styleFormFieldOnFour,
                                        yearOptions,
                                        prepareDataSingleForSelect(yearOptions, [genesisAndAgeRecord.datA_ROK?.toString()]),
                                        YearOnChange,
                                        yearOptionsSliceCount
                                    )} />

                                    <SelectInput {...getSelectInputProps(
                                        "Pora roku",
                                        styleFormFieldOnFour,
                                        PoraRokuDict,
                                        prepareDataSingleForSelect(PoraRokuDict, [genesisAndAgeRecord.porA_ROKU_DO_SID]),
                                        PoraRokuAfterOnChange
                                    )} />
                                    <SelectInput {...getSelectInputProps(
                                        "Rok",
                                        styleFormFieldOnFour,
                                        yearOptions,
                                        prepareDataSingleForSelect(yearOptions, [genesisAndAgeRecord.datA_ROK_DO?.toString()]),
                                        YearAfterOnChange,
                                        yearOptionsSliceCount
                                    )} />
                                </> : null
                                }

                            </> : null
                        }</> : null} <br />
                    <TextAreaField {...textAreaTimeProps} /> <br />
                    <TextAreaField {...textAreaDevelopmentProps} /> <br />
                    <SelectInput style={styleFormField} label="Przyczyny ruchu osuwiskowego"
                        hasInputTags={true} options={MovementCauseDict} onlySingleTag={false}
                        selectedOptions={selectedMovementCause} onChange={handleMovementCauseOnChange}
                        configValidation={createConfigValidation("onlyRequired")} validationError={checkValidation} />
                    {props.collectiveEdition ? <>
                        <div style={styleFormFieldHalf}></div>
                        <ButtonField {...getBtnProps(GenesisAndAgeTypes.Development, editRow ? "Zapisz zmiany w zdarzeniu" : "Dodaj zdarzenie", addCircleIcon, classNameBtn.Small, true)}></ButtonField>
                    </> : <>
                        <div style={styleFormFieldHalf}></div>
                        <ButtonField {...getBtnProps(GenesisAndAgeTypes.Development, editRow ? "Zapisz zmiany w zdarzeniu" : "Dodaj zdarzenie", addCircleIcon, classNameBtn.Small, true)}></ButtonField>
                    </>}
                </> :
                    null
            }</>
    }

    return (
        <>
            <div ref={(node: any) => { if (!props.collectiveEdition) getFieldRef(node, KROFieldDict.wiekGen_sekcja, props.getMapForComment!) }} style={{ width: '100%' }}></div>
            <h2 ref={(node) => getItemRef(node, NavHeadingsKROEnum.GenesisAndAge, props.getMapForNavScroll!)} style={{ width: '100%' }}
                onClick={() => { if (props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.wiekGen_sekcja); }}
            >8. Wiek i geneza osuwiska</h2>
            {props.collectiveEdition ? <>
                <div className="collective-input-container">
                    <h3 style={{ width: '100%' }} className='collective-section'>Dodaj zdarzenie <CollectiveLabelChip isAuto={false} /></h3>
                </div>
                <ButtonField {...getBtnProps(GenesisAndAgeTypes.Creation, "Powstanie", addCircleIcon)}></ButtonField>
                <div className="collective-block-genesis">{renderTime()}</div>
                <CollectiveSelectField top={false} value={startDevelopments} title={"Wiek i geneza osuwiska"}
                    forms={props.forms} keyName={CollectivePreviewKey.wiekiGeneza} actions={props.actions} single={false}
                    dics={{ "MovementCauseDict": MovementCauseDict, "EventeTypeDict": EventeTypeDict, "PoraRokuDict": PoraRokuDict }}
                    setActions={props.setActions} onDelete={props.onDelete}>
                    <div style={{ width: '100%' }}><Table {...tableProps} /></div>
                </CollectiveSelectField>
            </> : <>
                {!props.editMode && renderSectionCommentBtn(props.markedFieldForCommentFiltering === KROFieldDict.wiekGen_sekcja, false, "8. Wiek i geneza osuwiska", props.setNewCommentFieldDetails!, KROFieldDict.wiekGen_sekcja)}
                {props.editMode && <>
                    <h3 style={{ width: '100%' }}>Dodaj zdarzenie</h3>
                    <ButtonField {...getBtnProps(GenesisAndAgeTypes.Creation, "Powstanie", addCircleIcon)}></ButtonField>
                    <ButtonField {...getBtnProps(GenesisAndAgeTypes.Development, "Rozwój w czasie", addCircleIcon)}></ButtonField>
                </>}
                {renderTime()}
                <Table {...tableProps} />
            </>}
            {confirmation &&
                <ConfirmModal width={"660px"} height={"auto"}
                    confirmTitle={"Tak, usuń zdarzenie"}
                    onConfirm={confirm}
                    cancelTitle={"Anuluj"}
                    onCancel={cancel}
                    question={getQuestion()}
                    refocus={refocus}
                />}
        </>
    )
}

export default GenesisAndAge;